import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import useFirebase from "../../../../useFirebase";

const initialValue = [
  {
    Name: "Web monitoring",
    ID: 1,
    isChecked: true
  },
  {
    Name: "Set by parent",
    ID: 2,
    isChecked: true
  },
  {
    Name: "Used by child",
    ID: 3,
    isChecked: true
  },
];

const KeyWordStatsFilter = ({
  showModal,
  closeModal,
  filterData,
  setFilterData,
}) => {

  const { getCollectionData } = useFirebase();
  const { keystrokesmonitoring } = useSelector(
    ({ setRules }) => setRules?.setRulesData
  );

  const { keystrokesdata } = keystrokesmonitoring || {};

  const [categories, setCategories] = useState(initialValue);
  const { selectedDeviceData } = useSelector(({ dashboard }) => dashboard);
  const [selectedKeyWords, setSelectedKeyWords] = useState(
    filterData.selectedKeyWords
  );
  const [selectedPackages, setSelectedPackages] = useState(
    filterData.selectedPackages
  );

  useEffect(() => {
    if (selectedDeviceData && showModal) {
      getCollectionData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData, showModal]);

  useEffect(() => {
    if (filterData) {
      setSelectedKeyWords(filterData.selectedKeyWords);
      setSelectedPackages(filterData.selectedPackages);
    }
  }, [showModal, filterData]);

  const handleCheckboxChange = (categoryId) => {
    const tempCat = [...categories];
    const index = tempCat?.findIndex((item) => item?.ID === categoryId);
    tempCat[index]['isChecked'] = !tempCat[index]['isChecked'];
    setCategories(tempCat);
  };
  const handleCheckboxChangeForKeyWord = (word) => {
    const updatedSelectedKeywords = selectedKeyWords.includes(word)
      ? selectedKeyWords.filter((id) => id !== word)
      : [...selectedKeyWords, word]; 
    setSelectedKeyWords(updatedSelectedKeywords);
  };

  const handleSave = () => {
    const updatedSelectedCategoryIds = categories
      .filter((category) => category.isChecked)
      .map((category) => category.ID);
  
    const updatedFilterData = {
      selectedPackages,
      selectedCategoryIds: updatedSelectedCategoryIds,
      selectedKeyWords,
    };
  
    setFilterData(updatedFilterData);
  
    setTimeout(() => {
      closeModal(); 
    }, 0);
  };
  
  // Function to clear all checkboxes
  const handleClearAll = () => {
    setSelectedPackages([]);
  };

  
  return (
    <>
      <Modal
        show={showModal}
        size="sm"
        className="custom-modal blur-bg"
        centered
      >
        <Modal.Header>
          <div className="border-0 pb-0 d-flex justify-content-between w-100">
            <h6 className="modal-title text-blue-900">Filters</h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
        </Modal.Header>
        <Modal.Body className="py-1 px-4">
          <div className="modal-body">
            <p className="text-small text-gray text-uppercase mb-3 mt-6">
              Keyword Filters
            </p>
            {categories?.map((item) => (
              <div
                key={item?.ID}
                className="d-flex align-items-center gap-2 mb-3"
              >
                <h6 className="text-blue-900 mb-0">{item?.Name}</h6>
                <input
                  className="form-check-input ms-auto"
                  type="checkbox"
                  value={item?.ID}
                  id={`category_${item?.ID}`}
                  onChange={() => handleCheckboxChange(item?.ID)}
                  checked={item?.isChecked}
                />
              </div>
            ))}
            <p className="text-small text-gray text-uppercase mb-3 mt-6">
              Keywords
            </p>

            {keystrokesdata?.keystroke_keywords?.map((item, index) => (
              <div key={index} className="d-flex align-items-center gap-2 mb-3">
                <h6 className="text-blue-900 mb-0">{item}</h6>
                <input
                  className="form-check-input ms-auto"
                  type="checkbox"
                  value={`keyword_${index}`}
                  id={`keyword_${index}`}
                  onChange={() => handleCheckboxChangeForKeyWord(item)}
                  checked={selectedKeyWords.includes(item)}
                />
              </div>
            ))}
            {/* <p className="text-small text-gray text-uppercase mb-3">By app</p>
            {appData?.map((item, index) => (
              <div key={index} className="d-flex align-items-center gap-2 mb-3">
                <div className="icon-wrap icon-sm border-0 p-0">
                  <img src={item?.image} alt="" />
                </div>
                <h6 className="text-blue-900 mb-0">{item?.app_name}</h6>
                <input
                  className="form-check-input ms-auto"
                  type="checkbox"
                  value={`category_${index}`}
                  id={`category_${index}`}
                  onChange={() => handleAppCheckbox(item?.appPackageName)}
                  checked={selectedPackages.includes(item?.appPackageName)}
                />
              </div>
            ))} */}
            <div className="grid gap-3 mt-6">
              <button
                className="btn btn-outline-primary g-col-6"
                type="button"
                onClick={handleClearAll}
              >
                <span className="btn-upper-case">Clear all</span>
              </button>
              <button
                className="btn btn-primary g-col-6"
                type="button"
                onClick={handleSave}
              >
                <span className="btn-upper-case">Save</span>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default KeyWordStatsFilter;
